<template>
	<v-app-bar height="100">
		<v-tab to="/" style="padding: 0px;">
			<img :src="logo" style="height:200px"/>
		</v-tab>
		<v-spacer/>
		<v-icon class="phone-icon mr-2" color="primary">mdi-phone</v-icon><p>+49 341 3988860</p>
		<v-btn fab text>
			<v-icon color="primary">mdi-twitter</v-icon>
		</v-btn>
		<v-btn fab text>
			<v-icon color = "primary">mdi-facebook</v-icon>
		</v-btn>
	</v-app-bar>
</template>

<script>
	export default {
		name: "TopBar",
		
		data: function() {
			return {
				logo: require("../../assets/400dpiLogo.png")
			}
		}
	}
</script>

<style scoped>
	p.display-main {
		color: #ff922e;
		cursor: pointer;
	}
	p.display-main:hover {
		color: #428bca;
	}
	.phone-icon + p {
		margin: 0 1em;
		color: #ff922e;
	}
	img {
		height: 200%;
	}
</style>